<script setup lang="ts">
import type { InfoLevel } from "@/model/baseTypes";
import { linkColors } from "@/model/colors";

defineProps<{ linkState: InfoLevel }>();
</script>

<template>
  <svg class="flash-icon" width="20" height="20" role="presentation">
    <circle cx="10" cy="10" r="10" fill="#ffffff" />
    <path
      d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM9 16V11H5L11 4V9H15L9 16Z"
      :fill="linkColors[linkState]"
    />
  </svg>
</template>
